import $ from "jquery";

$(".menu-toggler").click(function () {
	$(this).toggleClass("menu-toggler--opened");
	$(".header__nav-wrapper:not('.header__nav-wrapper--secondary--desktop')").toggleClass("menu--opened");
	$('.handheld-header__nav-wrapper-overlay').toggleClass("menu--opened");
	$('.top-menu').toggleClass("menu--opened");
	$('.site-header').toggleClass("menu--opened");

	if($(this).attr("aria-expanded") === "true") {
        $(this).attr("aria-expanded", "false")
    } else {
        $(this).attr("aria-expanded", "true")
    }
});

$('.header__nav a[href="#"]').click(function (e) {
	e.preventDefault();
});

if (window.matchMedia('(max-width: 1023px)').matches) {
	$("#main-menu .menu-item-has-children").append('<button class="toggle-sub-menu"></button>');

	$("#main-menu .toggle-sub-menu").click(function (e) {
		$(this).parent().toggleClass("menu-item--opened");
	});
}


$(window).on('resize', function() {
	if(window.matchMedia('(max-width: 1024px)').matches && $('.toggle-sub-menu').length === 0) {
		$("#mobile-menu .menu-item-has-children").append('<button class="toggle-sub-menu"></button>');
		$(".toggle-sub-menu").on('click', function () {
			$(this).parent().toggleClass("menu-item--opened");
		});
	}
})
